import { ReactNode } from "react";
import { useMaintenanceStatusQuery } from "../queries/useMaintenanceStatus";
import Maintenance from "../pages/Maintenance";
import { Loading } from "./loader";

interface MaintenanceWrapperProps {
  children: ReactNode;
}

export const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  const {
    data: maintenanceStatus,
    isLoading,
    error,
  } = useMaintenanceStatusQuery();

  // Show loading state while checking maintenance status
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  // If there's an error checking maintenance status, proceed normally
  // (fail-safe approach - don't block users if API is down)
  if (error) {
    console.warn("Failed to check maintenance status:", error);
    return <>{children}</>;
  }

  // If maintenance mode is enabled, show maintenance page
  if (maintenanceStatus?.isMaintanenceMode) {
    return <Maintenance />;
  }

  // Otherwise, show normal app content
  return <>{children}</>;
};
